<button
  class="alert-banner"
  *ngIf="openAlertsCount > 0"
  (click)="navigateToAlertPage()"
  title="Click to view open alerts">
  There are {{ openAlertsCount }} open alerts for this environment. Click here to view details.
</button>